import React from "react";
import { Link } from "react-router-dom";

export const DroppingSoonGrid = ({ items, accent = "#FFD700" }) => {
  if (!items.length) return null;
  return (
    <div className="mt-20" data-testid="dropping-soon-grid">
      <p
        className="af-mono text-[10px] uppercase tracking-[0.3em] mb-3"
        style={{ color: accent }}
      >
        // Dropping soon
      </p>
      <h2 className="af-display text-3xl md:text-4xl font-black uppercase tracking-tighter">
        Prices coming soon
      </h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-10">
        {items.map((c) => (
          <Link
            to={`/product/${c.slug}`}
            key={c.slug}
            className="af-card overflow-hidden group block"
            data-testid={`dropping-soon-${c.slug}`}
          >
            <div className="aspect-[4/3] overflow-hidden">
              <img
                src={c.image}
                alt={c.name}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-5">
              <div className="flex items-start justify-between gap-3">
                <h3 className="font-bold uppercase tracking-wide text-sm">{c.name}</h3>
                <span
                  className="af-mono text-[9px] uppercase tracking-[0.2em] px-2 py-1 whitespace-nowrap border"
                  style={{ color: accent, borderColor: `${accent}4D` }}
                >
                  Price TBA
                </span>
              </div>
              <p className="text-zinc-500 text-xs mt-2">{c.tagline}</p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};
